<template>
  <div style="width: 100%;" class="custom-container">
    <v-row dense no-gutters>
      <v-col cols="12">
        <Table
          :key="tableKey"
          :items="users"
          :loading="loading"
          @activeOnly="activeOnlyFunction($event)"
          @changeStatus="changeStatus($event)"
          @fetchUsers="fetchUsers($event)"
        ></Table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Table from './UsersDatatable'
import {
  getUsersUsingGET as getUsers,
  disableUserUsingGET as disableUser,
  enableUserUsingGET as enableUser
} from '@/utils/api'
import { mapActions } from 'vuex'

export default {
  components: {
    Table
  },
  data() {
    return {
      activeOnly: true,
      tableKey: 0,
      loading: false,
      users: { items: [], meta: {} }
    }
  },
  computed: {},
  created() {
    if (this.$route.params && this.$route.params.message) {
      this.addSnackbar({
        message: this.$route.params.message,
        timeout: 5000,
        color: 'success'
      })
    }
  },
  methods: {
    ...mapActions('app', ['addSnackbar']),

    activeOnlyFunction(event) {
      this.activeOnly = event.activeOnly

      this.fetchUsers(event.options)
    },
    fetchUsers(options) {
      this.loading = true

      const obj = {}

      if (options) {
        if (options.options && options.options.itemsPerPage !== -1) {
          obj.page = options.resetPage ? 1 : options.options.page || 1
          obj.size = options.options.itemsPerPage || 25
        } else {
          obj.page = 1
          obj.size = 25
        }
      } else {
        obj.page = 1
        obj.size = 25
      }

      if (options && options.search && options.search.length > 1) {
        obj.name = options.search
      }

      if (options?.options?.sortDesc && options.options.sortDesc.length > 0) obj.orderDirection = options.options.sortDesc[0] ? 'DESC' : 'ASC'

      if (options && options.options && options.options.sortBy && options.options.sortBy.length > 0) {
        obj.orderField = options.options.sortBy[0]
      }

      if (this.activeOnly) obj.status = 'ACTIVE'

      getUsers(obj)
        .then((res) => {
          this.users = res.data.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
    },
    async changeStatus (item) {
      try {
        const res = item.status === 'ACTIVE' ? await disableUser({ id: item.id }) : await enableUser({ id: item.id })

        if (res.status !== 200) {
          this.addSnackbar({
            message: this.$lang.errors.userStatusUpdate,
            timeout: 5000,
            color: 'error'
          })

          return
        }
        const successMessage = item.status !== 'ACTIVE' ? this.$lang.success.userActivated : this.$lang.success.userDeactivated

        this.addSnackbar({
          message: successMessage,
          timeout: 5000,
          color: 'success'
        })
        const changedItem = this.users.items.find((x) => x.id === item.id)

        if (changedItem) this.users.items.find((x) => x.id === item.id).status = res.data.data.status

      } catch (err) {
        this.addSnackbar({
          message: err,
          timeout: 5000,
          color: 'error'
        })
      }
    }
  }
}
</script>
